import { css } from 'styled-components';

const sizes = {
  large: 1200,
  desktop: 992,
  tablet: 768,
  phone: 576,
};

export const media = Object.keys(sizes).reduce((acc: any, label: string) => {
  acc[label] = (...args: any[]) => css`
    @media (min-width: ${sizes[label]}px) {
      ${css.call(undefined, ...args)};
    }
  `;
  return acc;
}, {});

const widthMixin = css`
  ${media.tablet`
    width: 760px;
  `};
  ${media.desktop`
    width: 992px;
  `};
  ${media.large`
    width: 1200px;
  `};
`;

export { widthMixin };



// WEBPACK FOOTER //
// ./src/components/mixins.tsx